import { LOCAL_STORAGE_AUTH_TOKEN, LOCAL_STORAGE_REFRESH_TOKEN } from '../constants/localStorage';

export class LocalStorageService {
  private static LSEnabled() {
    return typeof window !== 'undefined';
  }

  private static readWithSync(key: string): string | null {
    if (!LocalStorageService.LSEnabled()) return null;

    const fromSession = sessionStorage.getItem(key);
    const fromLocal = localStorage.getItem(key);

    if (fromSession) {
      if (!fromLocal) {
        localStorage.setItem(key, fromSession);
      }
      return fromSession;
    }

    if (fromLocal) {
      sessionStorage.setItem(key, fromLocal);
      return fromLocal;
    }

    return null;
  }

  private static writeToBoth(key: string, value: string): void {
    if (!LocalStorageService.LSEnabled()) return;
    sessionStorage.setItem(key, value);
    localStorage.setItem(key, value);
  }

  private static removeFromBoth(key: string): void {
    if (!LocalStorageService.LSEnabled()) return;
    sessionStorage.removeItem(key);
    localStorage.removeItem(key);
  }

  static getAccessToken(_useLocalStorage: boolean = false): string | null {
    return LocalStorageService.readWithSync(LOCAL_STORAGE_AUTH_TOKEN);
  }

  static setAccessToken(token: string, _useLocalStorage: boolean = false): void {
    LocalStorageService.writeToBoth(LOCAL_STORAGE_AUTH_TOKEN, token);
  }

  static clearAccessToken(_useLocalStorage: boolean = false): void {
    LocalStorageService.removeFromBoth(LOCAL_STORAGE_AUTH_TOKEN);
  }

  static getRefreshToken(_useLocalStorage: boolean = false): string | null {
    return LocalStorageService.readWithSync(LOCAL_STORAGE_REFRESH_TOKEN);
  }

  static setRefreshToken(token: string, _useLocalStorage: boolean = false): void {
    LocalStorageService.writeToBoth(LOCAL_STORAGE_REFRESH_TOKEN, token);
  }

  static clearRefreshToken(_useLocalStorage: boolean = false): void {
    LocalStorageService.removeFromBoth(LOCAL_STORAGE_REFRESH_TOKEN);
  }

  static clearAllTokens(): void {
    LocalStorageService.clearAccessToken();
    LocalStorageService.clearRefreshToken();
  }

  static getAccessTokenFromAnyStorage(): string | null {
    return LocalStorageService.getAccessToken();
  }

  static getRefreshTokenFromAnyStorage(): string | null {
    return LocalStorageService.getRefreshToken();
  }
}
